/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const CompareHeader = styled.div({
  padding: `${token('space.100')} 0`,
  h2: {
    font: token('font.heading.xsmall'),
    marginTop: token('space.200'),
  },
});

export const CompareBranchFilter = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
});

export const ForkBoxSurround = styled.div({
  borderRadius: `${borderRadius()}px`,
  border: `1px solid ${token('color.border')}`,
  padding: '10px',
});

export const Arrow = styled.div({
  display: 'flex',
  alignItems: 'center',
  padding: `0 ${token('space.200')}`,
});

export const ArrowWithLabelSpacer = styled.div({
  display: 'flex',
  alignItems: 'center',
  padding: `0 ${token('space.200')}`,
  marginTop: '25px',
});

export const BranchLabels = styled.div({
  flexDirection: 'column',
  display: 'flex',
  justifyContent: 'space-around',
});

export const PRBranchLabels = styled(BranchLabels)({
  flexGrow: 1,
});

export const BranchLabel = styled.div({
  '> span': {
    display: 'inline-block',
  },
  '> span:first-child': {
    marginLeft: '-3px',
  },
  '> span:not(:first-child)': {
    paddingLeft: token('space.100'),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export const PRNonSelectableBranchLabel = styled(BranchLabel)({
  marginTop: '1px',
  height: '40px',
  display: 'flex',
  paddingLeft: token('space.150'),
});

export const Label = styled.label({
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.semibold'),
  color: token('color.text.subtlest'),
  display: 'inline-block',
  marginBottom: token('space.050'),
  marginTop: 0,
});

export const FieldRefSelector = styled.div({
  minWidth: '250px',
  margin: token('space.050'),
});

export const FieldHeightSpacer = styled.div({
  marginTop: token('space.100'),
});
